import axiosInstance from "@/composables/axios-instance";

const state = {
    usersList: []
};

const getters = {
    getUsersList(state) {
        return state.usersList;
    }
};

const mutations = {
    setUsersList(state, list) {
        state.usersList = list;
    },
    clearUsersList(state){
        state.usersList = [];
    }
};

const actions = {
    getUsersListFromApi({ commit }, filter) {
        return axiosInstance.get("/authenticate/users/list/", {
            params: {
                first_name: filter.first_name,
                last_name: filter.last_name,
                username: filter.username,
                page_size: filter.page_size
            }
        }).then(response => {
            commit("setUsersList", response.data);
        }).catch(error => {
            console.error(error);
        })
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};